module.exports = __webpack_public_path__ + "static/secondMovementTransformedArranged-b6838cff9ef6f09e875b4fcc1740714f.mp3";